<script setup lang="ts">
import { PAGES } from '../../constants'
import TabIcon from '../../TabIcon.vue'
import { computed } from 'vue'

const props = defineProps<{
  name: string
  demo?: boolean
  smartbook?: boolean
  devState?: string
}>()

const page = computed(() => PAGES.find(e => e.name === props.name) || { text: '', smartbook: false })
const underConstruction = computed(() => {
  if (!page.value.smartbook) return false
  switch (props.devState) {
    case 'full':
      return false
    case 'video_only':
      return props.name !== 'video'
    case 'not_ready':
      return true
    default:
      return false
  }
})
</script>

<template>
  <a
    class="student-mainpage-link-card"
    :class="{
      [`student-mainpage-link-card_name_${name}`]: true,
      'student-mainpage-link-card_demo': demo,
      'student-mainpage-link-card_under-construction': underConstruction
    }"
  >
    <v-icon v-if="smartbook" class="student-mainpage-link-card__star" size="16"> mdi-star </v-icon>
    <div class="student-mainpage-link-card__img">
      <TabIcon :size="88" :tab="name" />
    </div>
    <span>{{ page.text }}</span>
  </a>
</template>

<style lang="scss">
@use '~/styles/pages/student2/screen' as s2;

.student-mainpage-link-card {
  all: unset;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 16px;
  text-align: center;

  border-radius: 20px;
  border: 1px solid $lightGray;
  transition:
    border 0.1s,
    margin 0.1s;

  font-size: 18px;
  font-weight: 700;
  line-height: 21.78px;
  text-transform: uppercase;
  cursor: pointer;

  @include s2.mobile {
    font-size: 13px;
    line-height: 16px;
    gap: 8px;
  }

  @include s2.very-small-mobile {
    font-size: 12px;
    line-height: 14px;
    padding: 8px;
  }

  position: relative;

  &:hover {
    border: 4px solid var(--hover_border_color);
    margin: -3px;
  }

  &__img {
    flex: 1 0 28px;
    min-width: 28px;
    min-height: 28px;
    max-width: 88px;
    max-height: 88px;
    aspect-ratio: 1;

    picture,
    img {
      width: 100%;
      height: 100%;
    }
  }

  &_demo::before,
  &_under-construction::before {
    position: absolute;
    top: 16px;
    left: 16px;
    background: rgba(black, 0.6);
    @include text-overline;
    padding: 4px 8px;
    color: white;
    border-radius: 999px;

    @include s2.mobile {
      top: 8px;
      left: 8px;
      font-size: 10px;
      padding: 2px 8px;
    }
  }

  &_demo::before {
    content: 'DEMO';
  }

  &_under-construction::before {
    content: 'В РАЗРАБОТКЕ';
  }

  &_name {
    &_audio,
    &_roundup {
      --hover_border_color: #{$red};
      background: $lightenRed;
    }
    &_songs {
      --hover_border_color: #{$blue};
      background: $lightenBlue;
    }
    &_games {
      --hover_border_color: #fbd500;
      background: #fff8c2;
    }
    &_video {
      --hover_border_color: #ac7bfc;
      background: #e3d2ff;
    }
    &_avatar {
      --hover_border_color: #{$green};
      background: #ccebb3;
    }
    &_shop {
      --hover_border_color: #{$orange};
      background: $lightenOrange;
    }
  }

  &_under-construction {
    background: $lightGray;
    pointer-events: none;
    & > * {
      opacity: 0.5;
    }
  }

  &__star {
    position: absolute;
    top: 20px;
    right: 16px;
    color: $orange;
  }
}
</style>
